import type { ContenidoAyuda } from "@/ui/AyudaVista";

/**
 * Ayuda de Enlaces cortos (r.arknex.net). Antes, el «?» con globito y los
 * tooltips de copiar / QR / editar / eliminar.
 *
 * `veTodos` = admin o soporte: ven los enlaces de todos; los demás, solo los
 * suyos (el backend filtra igual).
 */
export function ayudaEnlaces({ veTodos }: { veTodos: boolean }): ContenidoAyuda {
  return {
    intro: (
      <p>
        Pega una dirección larga (Drive, Notion, un documento) y obtén una corta en{" "}
        <code>r.arknex.net</code> para mandársela al cliente.{" "}
        {veTodos ? "Aquí ves los enlaces de todo el equipo." : "Aquí ves los enlaces que tú creaste."}
      </p>
    ),
    secciones: [
      {
        titulo: "Qué hace cada botón",
        items: [
          {
            label: "Acortar",
            text: "Crea el enlace corto y lo copia solo al portapapeles. Sale gris mientras no pegues una dirección.",
          },
          {
            label: "Terminación personalizada",
            text: "Opcional: lo que va después de r.arknex.net/ (por ejemplo, manual-queclink). De 4 a 32 letras, números, guion o guion bajo, y que nadie más la esté usando. Vacía, se inventa una de 6.",
          },
          {
            label: "Reusar el existente",
            text: "Si esa misma dirección ya tenía un enlace corto (de quien sea), se ofrece usar ese en vez de crear otro.",
          },
          { label: "Copiar / copiar", text: "Copia el enlace corto al portapapeles." },
          { label: "El enlace corto", text: "Tócalo para abrirlo en otra pestaña (cuenta como visita)." },
          { label: "QR", text: "Enseña el código QR del enlace corto y deja descargarlo como imagen." },
          {
            label: "editar",
            text: "Cambia a dónde lleva el enlace sin cambiar la terminación: los enlaces ya repartidos siguen sirviendo. Sale en los enlaces que tú creaste; a un admin, en todos.",
          },
          {
            label: "eliminar",
            text: "Borra el enlace (te pide confirmar): deja de funcionar al instante y quien lo abra verá «página no encontrada». No se deshace. Sale en los enlaces que tú creaste; a un admin, en todos.",
          },
          { label: "Buscador", text: "Busca por título de la página, terminación o dirección de destino." },
        ],
      },
      {
        titulo: "Qué significa cada dato",
        items: [
          { label: "→ dirección", text: "A dónde lleva el enlace corto." },
          {
            label: "N visitas · última hace…",
            text: "Cuántas veces se abrió el enlace y cuándo fue la última (s = segundos, m = minutos, h = horas, d = días, a = años).",
          },
          { label: "creado por…", text: "Quién lo hizo." },
        ],
      },
      {
        titulo: "Atajos de teclado",
        items: [
          { label: "Ctrl + K", text: "Pone el cursor en el campo de la dirección." },
          { label: "Ctrl + Enter", text: "Con el cursor en el formulario, crea el enlace corto." },
        ],
      },
    ],
  };
}
